import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const confirmedFlags = (c) => (c.violations || []).filter((v) => (v.ai_status || "confirmed") === "confirmed" && (v.severity === "medium" || v.severity === "high"));

// Gently toasts when a monitored candidate gains a new confirmed integrity flag,
// so reviewers notice without refreshing. Skips the first render (no backfill spam).
export function useLiveFlagToasts(candidates = [], { enabled = true } = {}) {
  const nav = useNavigate();
  const prev = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    const counts = {};
    for (const c of candidates) counts[c.id] = confirmedFlags(c).length;
    if (prev.current) {
      for (const c of candidates) {
        const was = prev.current[c.id];
        const now = counts[c.id] ?? 0;
        if (was !== undefined && now > was) {
          const latest = confirmedFlags(c).slice(-1)[0];
          toast.warning(`New integrity flag · ${c.name}`, {
            description: latest?.label || "A new proctoring signal was confirmed",
            action: { label: "Review", onClick: () => nav(`/recruiter/candidate/${c.id}?tab=proctoring`) },
          });
        }
      }
    }
    prev.current = counts;
  }, [candidates, enabled, nav]);
}
